import styled from 'styled-components';
import { Link } from 'react-router-dom'

export const LinkWrapper = styled(Link)`
  font-size: 20px;
  padding: 6px;
`;
